import React from "react";
import OcrPage from "../features/ocr/OcrPage.jsx";

export default function Ocr() {
  return <OcrPage />;
}
